<div class="contenedor-tabla">
    <mat-table
        class="solicitud-tabla"
        #table
        [dataSource]="dataSource"
        matSort
        matSortActive="nombre"
        matSortDisableClear
        matSortDirection="desc"
        [@animateStagger]="{ value: '50' }"
        fusePerfectScrollbar
    >
        <ng-container matColumnDef="select">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let grupo">
                <div>
                    <mat-checkbox
                        *ngIf="esSupervisor && !eliminado"
                        (click)="$event.stopPropagation()"
                        (change)="toggleSelect($event, grupo)"
                        [aria-label]="checkboxLabel(grupo)"
                    >
                    </mat-checkbox>
                </div>
            </mat-cell>
        </ng-container>

        <!-- <ng-container matColumnDef="id">
            <mat-header-cell *matHeaderCellDef mat-sort-header
                >Id</mat-header-cell
            >
            <mat-cell *matCellDef="let grupo">
                <span
                    ><strong>{{ grupo.id }} </strong></span
                >
            </mat-cell>
        </ng-container>-->

        <ng-container matColumnDef="nombre">
            <mat-header-cell *matHeaderCellDef mat-sort-header
                >Especialidad</mat-header-cell
            >
            <mat-cell *matCellDef="let grupo">
                <p>
                    <strong>{{ grupo.descripcion }}</strong>
                </p>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fecha">
            <mat-header-cell *matHeaderCellDef mat-sort-header
                >Fecha Solicitud</mat-header-cell
            >
            <mat-cell *matCellDef="let grupo">
                <p>
                    {{ grupo.fecha | date: "dd-MM-YYYY HH:mm" }}
                </p>
            </mat-cell>
        </ng-container>

        <mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
        ></mat-header-row>
        <mat-row *matRowDef="let grupo; columns: displayedColumns"></mat-row>
    </mat-table>
    <mat-paginator
        #paginator
        [length]="total"
        [pageIndex]="0"
        [pageSize]="10"
        [pageSizeOptions]="[5, 10, 25, 100]"
    >
    </mat-paginator>
    <p *ngIf="grupoServiciosSolicitados.length === 0">
        No hay solicitudes de especialidad por el momento
    </p>
</div>
<div
    fxLayout="row"
    fxLayoutAlign.lt-md="center center"
    fxLayoutAlign="end end"
    fxLayoutGap="10px"
>
    <button
        *ngIf="esSupervisor && !eliminado"
        mat-raised-button
        color="accent"
        class="mt-16"
        [disabled]="selection.isEmpty()"
        (click)="aprobar()"
    >
        Aprobar Solicitud
    </button>
</div>

<!-- /div -->
